export default "__VITE_ASSET__d82c1acd__"